import React, { useEffect } from 'react';
import token from 'vindi-ds-tokens';
import { Box, Card, Button } from 'vindi-ds-components';
import toBrl from '@utils/format_currency';
import Header from '@pages/product/components/price_simulator/header';
import Total from '@pages/product/components/price_simulator/total';
import useTotal from '@pages/product/components/price_simulator/use_total';
import Field from './field';
import usePriceField from './use_price_field';
import calculatePrice from './utils/calculatePrice';

function PriceSimulator({ pricingSchema }) {
  const {
    price,
    schema_type: schemaType,
  } = pricingSchema;

  const {
    recurrence, setRecurrence,
  } = usePriceField();
  const { total, setTotal } = useTotal({ price, recurrence });

  useEffect(() => {
    setTotal(0);
  }, [price, recurrence]);

  return (
    <Box mt={token.spacing.small.value}>
      <Card padding='xs'>
        <Header />
        <Box display='flex' justifyContent='space-between' marginBottom='1em' css={{ gap: '0.5em' }}>
          { ['flat', 'per_unit'].includes(schemaType)
    && <Field title='Preço' disabled value={toBrl(price)} />}
          <Field title='Recorrência' type='number' handleChange={setRecurrence} />
        </Box>
        <SimulatorButton
          setTotal={setTotal}
          pricingSchema={pricingSchema}
          recurrence={recurrence}
        />
        { total > 0 && <Total value={total} /> }
      </Card>
    </Box>
  );
}

const SimulatorButton = ({
  setTotal, recurrence, pricingSchema,
}) => (
  <Button
    style={{ margin: '0', width: '100%' }}
    type='button'
    variant='secondary'
    size='small'
    onClick={() => {
      const totalPrice = calculatePrice(pricingSchema, recurrence);
      setTotal(totalPrice);
    }}
  >Simular
  </Button>
);

export default PriceSimulator;
